import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { DsnCompteRenduDto } from "../../../dto/GenApi.iNotPaie.Dto/DsnCompteRenduDto";
import { LigneCompteRenduDto } from "../../../dto/GenApi.iNotPaie.Dto/LigneCompteRenduDto";
import { DsnDeclarationAnomalieDto } from "../../../dto/GenApi.iNotPaie.Dto/DsnDeclarationAnomalieDto";
import { NeoresCodeEffectif } from "../../../dto/GenApi.iNotPaie.Dto/NeoresCodeEffectif";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { DsnNatureDeclaration } from "../../../dto/GenApi.iNotPaie.Dto/DsnNatureDeclaration";
import EventConstants from "../../Controls/EventConstants";
import { EventBus } from "../../Controls/EventBus";

@Component
export default class ModalCompteRenduDsnComponent extends Vue {
	public undefinedChoice = "*";
	public valueSalarie = "*s";
	public valueAutres = "*a";
	public valueIdentifiant = "*i";

	public isLoading = 0;
	public compteRendu: DsnCompteRenduDto = { IdDsnMetadata: 0, NatureDeclaration: DsnNatureDeclaration.MENSUELLE, EstTauxPasSalarieActualise: false, ListeLignesCompteRenduDto: [] };
	public filteredList?: LigneCompteRenduDto[] = undefined;
	public ligneCompteRenduTous?: LigneCompteRenduDto = undefined;
	public ligneCompteRenduSelectionne?: LigneCompteRenduDto = undefined;

	public anomaliesList?: DsnDeclarationAnomalieDto[] = undefined;

	public natureSelectionnee: string = this.undefinedChoice;

	public salarieList?: string[] = undefined;
	public identifiantList?: string[] = undefined;
	public selectedSalarie: string = this.undefinedChoice;
	public selectedIdentifiant: string = this.undefinedChoice;

	public selectedAnomalieType: string = this.undefinedChoice;

	public Init(idDsnMetadata: number): void {
		this.isLoading++;
		this.clearModal();
    	ServicesFactoryInstance.DsnService.recupererCompteRendu(idDsnMetadata, data => {
			this.compteRendu = data;
			this.filteredList = data.ListeLignesCompteRenduDto ?? undefined;
			this.isLoading--;
    	}, () => this.isLoading--);
	}

	public refreshAllReturns(): undefined | void {
		this.anomaliesList = undefined;
		this.salarieList = undefined;
		this.identifiantList = undefined;

		if (!this.compteRendu.ListeLignesCompteRenduDto) {
    		return;
    	}

		this.filteredList = this.compteRendu.ListeLignesCompteRenduDto.filter(x => this.ligneCompteRenduSelectionne == undefined || x.Nature == this.ligneCompteRenduSelectionne?.Nature);

		if (this.ligneCompteRenduSelectionne != undefined) {
			if (this.ligneCompteRenduSelectionne.Declaration != undefined && this.ligneCompteRenduSelectionne.Declaration.Anomalies != undefined) {
				this.salarieList = this.ligneCompteRenduSelectionne.Declaration.Anomalies.filter(x => x.Salarie != undefined)
    				.map(x => (x.Salarie.Nom || "{Nom}") + " " + (x.Salarie.Prenom || "{Prenom}")).filter(function(item, i, ar) {
    					return ar.indexOf(item) === i;
    				});
				this.identifiantList = this.ligneCompteRenduSelectionne.Declaration.Anomalies.filter(x => x.Valeur != undefined && x.Valeur.Identifiant != undefined)
    				.map(x => x.Valeur.Identifiant!.toString()).filter(function(item, i, ar) {
    					return ar.indexOf(item) === i;
    				});
    		}
    	} else {
    		this.selectedSalarie = this.undefinedChoice;
    		this.selectedAnomalieType = this.undefinedChoice;
    	}
    	this.$forceUpdate();
	}

	public refreshAnomalies(): void {
		if (this.ligneCompteRenduSelectionne == undefined ||
            this.ligneCompteRenduSelectionne.Declaration == undefined ||
            this.ligneCompteRenduSelectionne.Declaration.Anomalies == undefined ||
            this.selectedAnomalieType == undefined) {
    		this.anomaliesList = undefined;

    		return;
    	}

    	switch (this.selectedAnomalieType) {
    		case this.valueAutres: {
    			// Choix Autre
    			// <=> Quand il n'y a pas de salarié ?
				this.anomaliesList = this.ligneCompteRenduSelectionne.Declaration.Anomalies.filter(x => x.Salarie == null || x.Salarie == undefined);
    			break;
    		}
    		case this.valueSalarie: {
    			// Choix Salarié
				this.anomaliesList = this.ligneCompteRenduSelectionne.Declaration.Anomalies.filter(x => x.Salarie != null && x.Salarie != undefined);

    			if (this.selectedSalarie != this.undefinedChoice) {
    				this.anomaliesList = this.anomaliesList.filter(x => ((x.Salarie.Nom || "{Nom}") + " " + (x.Salarie.Prenom || "{Prenom}")) == this.selectedSalarie);
    			}
    			break;
    		}
    		case this.valueIdentifiant: {
    			// Choix Identifiant
				this.anomaliesList = this.ligneCompteRenduSelectionne.Declaration.Anomalies.filter(x => x.Valeur != null || x.Valeur != undefined);
    			if (this.selectedIdentifiant != this.undefinedChoice) {
    				this.anomaliesList = this.anomaliesList.filter(x => x.Valeur.Identifiant == this.selectedIdentifiant);
    			}
    			break;
    		}
    		default: {
    			// Aucun choix
				this.anomaliesList = this.ligneCompteRenduSelectionne.Declaration.Anomalies.filter(x => x != null || x != undefined);
    			break;
    		}
    	}
	}

	public annuler(): void {
    	this.selectedAnomalieType = this.undefinedChoice;
    	this.selectedSalarie = this.undefinedChoice;
    	this.selectedIdentifiant = this.undefinedChoice;
    	this.filteredList = undefined;
		this.ligneCompteRenduSelectionne = undefined;
    	this.anomaliesList = undefined;
    	this.salarieList = undefined;
    	this.identifiantList = undefined;
    	$("#modalCompteRenduDsnComponent").modal("hide");
	}

	public telecharger(ligneCompteRendu: LigneCompteRenduDto): void {
		if (ligneCompteRendu.CodeDocumentGed == undefined) {
			return;
		}

		const codeDocumentGed = ligneCompteRendu.CodeDocumentGed ?? "";

    	this.isLoading++;
		ServicesFactoryInstance.DsnService.recupererDocumentGed(ligneCompteRendu.CodeDocumentGed, (r: Blob) => {
			const nomModele = `Retour${ligneCompteRendu.Nature}_${codeDocumentGed}.pdf`;

    		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(r, ligneCompteRendu.CodeDocumentGed);
    			this.isLoading--;
    		} else {
    			this.isLoading--;

    			const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = nomModele;
    			link.click();

    			NotificationServiceInstance.SendSuccess("La récupération du document s'est correctement déroulée !");
    		}
    	});
	}

	public getCodeEffectif(code: NeoresCodeEffectif): string {
    	return NeoresCodeEffectif[code];
	}

	public isVisibleMajTauxPas(ligne: LigneCompteRenduDto): boolean {
		if (!this.compteRendu ||
            !ligne ||
            this.compteRendu.NatureDeclaration != DsnNatureDeclaration.AMORCAGETAUXPAS ||
            ligne.Nature !== "94") {
			return false;
		}

		return true;
	}

	public mettreAJourTauxPas(): void {
		if (!this.compteRendu || this.compteRendu.EstTauxPasSalarieActualise) {
			return;
		}

		this.isLoading++;
		ServicesFactoryInstance.AmorcageTauxPASService.mettreAJourTauxPAS(this.compteRendu.IdDsnMetadata, () => {
			this.isLoading--;
			NotificationServiceInstance.SendSuccess("La mise à jour du Taux PAS du salarié a bien été effectuée !");
			this.compteRendu.EstTauxPasSalarieActualise = true;

			EventBus.$emit(EventConstants.DSN_REFRESH_CURRENT_LIST_AMORCAGE_TAUX_PAS);
		}, () => this.isLoading--);
	}

	public clearModal(): void {
		this.compteRendu = { IdDsnMetadata: 0, NatureDeclaration: DsnNatureDeclaration.MENSUELLE, EstTauxPasSalarieActualise: false, ListeLignesCompteRenduDto: [] };
		this.ligneCompteRenduSelectionne = this.ligneCompteRenduTous;
		this.filteredList = undefined;
		this.anomaliesList = undefined;
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/modalCompteRenduDsn/modalCompteRenduDsn.ts